import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchWalletBalances = createAsyncThunk(
  'walletBalances/fetchWalletBalances',
  async () => {
    const response = await api.get('/api/exchanges/wallet_balances/');
    return response.data.balances;
  }
);

const walletBalanceSlice = createSlice({
  name: 'walletBalances',
  initialState: {
    balances: [],
    loading: false,
    error: null,
    lastUpdated: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBalances.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWalletBalances.fulfilled, (state, action) => {
        state.loading = false;
        state.balances = action.payload;
        state.lastUpdated = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchWalletBalances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default walletBalanceSlice.reducer;
